import { ReactNode } from "react";
import { styled } from "@mui/material";

type ContainerProps = {
  children: ReactNode;
  flexDirection?: string;
  align?: string;
  id?: string;
};

const Content = styled("div")<{ flexDirection?: string, align?: string }>`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  align-items: ${(props) => props.align || "center"};
  margin: 40px auto;
  gap: 60px;
  max-width: 1600px;
  width: 100%;

  @media screen and (max-width: 1680px) {
    max-width: 1440px;
  }
  @media screen and (max-width: 1500px) {
    max-width: 1280px;
  }
  @media screen and (max-width: 1320px) {
    max-width: 1024px;
  }
  @media screen and (max-width: 1070px) {
      flex-direction: column;
      align-items: center;
      max-width: none;
      padding: 0 20px
  }
`;

const Container = ({ children, flexDirection, align, id }: ContainerProps) => {
  return (
    <Content flexDirection={flexDirection} align={align} id={id}>{children}</Content>
  );
};

export default Container;
